export enum LandingServiceStatus {
    DISABLED,
    ENABLED
}
